// src/App.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './components/Header';
import Footer from './components/Footer';
import Sidebar from './components/Sidebar';
import MainContent from './components/MainContent';
import './App.css';


const dev = window.location.hostname === "localhost";

axios.defaults.baseURL = dev
  ? "http://localhost:5002"   // direct backend in dev
  : "/api";  


// Set auth header if token exists on initial load
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export default function App() {
  const [collapsed, setCollapsed] = useState(false);
  const [page, setPage] = useState('home');
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  // ✅ Identical cleanup as in Login.jsx
  const handleGlobalLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    sessionStorage.clear();
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    // Note: We do NOT setPage('login') — preserve current behavior
  };

  // 🛡️ Global interceptor for session timeout / invalidation
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
          handleGlobalLogout(); // 👈 Full cleanup on auth failure
        }
        return Promise.reject(error);
      }
    );

    return () => axios.interceptors.response.eject(interceptor);
  }, []);

  return (
    <div className="app-container">
      <Header page={page} />
      <div className="content-wrapper">
        <Sidebar
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          setPage={setPage}
          user={user}
        />
        <MainContent page={page} setPage={setPage} user={user} setUser={setUser} />
      </div>
      <Footer />
    </div>
  );
}